import { useEffect } from "react";
import { healthDbEndpoint } from "../services/constants";

const DB_WAKEUP_TIMEOUT_MS = 10000;

/**
 * On mount, sends a single fire-and-forget GET request to the API health/db
 * endpoint to wake Azure SQL Serverless before the user interacts. Does not
 * block rendering or show errors; failures are ignored.
 */
export const DbWakeUp = () => {
  useEffect(() => {
    const baseUrl =
      import.meta.env.MODE === "development"
        ? import.meta.env.VITE_LOCAL_BASE_URL
        : import.meta.env.VITE_BASE_URL;

    if (!baseUrl || typeof baseUrl !== "string") return;

    const url = `${baseUrl.replace(/\/$/, "")}/${healthDbEndpoint}`;
    const controller = new AbortController();
    const timeoutId = setTimeout(
      () => controller.abort(),
      DB_WAKEUP_TIMEOUT_MS,
    );

    fetch(url, { signal: controller.signal })
      .catch(() => {})
      .finally(() => clearTimeout(timeoutId));
  }, []);

  return null;
};
